import { render } from "./Duruus.vue?vue&type=template&id=866d6df2&scoped=true"
import script from "./Duruus.vue?vue&type=script&lang=js"
export * from "./Duruus.vue?vue&type=script&lang=js"

import "./Duruus.vue?vue&type=style&index=0&id=866d6df2&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866d6df2"]])

export default __exports__